// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"8b862c6c","275":"7082e4e4","392":"2cadaf9e","523":"020df1b9","678":"fc0b0a50","831":"006de6a8","968":"020df1b9"}[chunkId] + ".chunk.css";
};